import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Eye } from "lucide-react";

export const Route = createFileRoute("/_app/rh/planning/$id/view")({
  loader: requirePermission(PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW),
  staticData: {
    title: "Voir le planning",
    icon: Eye,
    permission: PERMISSIONS.RH.FEUILLES_DE_TEMPS.VIEW,
  },
  component: ({ params }) => (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Voir le planning</h1>
      <p className="text-base-content/60">
        ID: {params.id} - La vue détaillée sera implémentée ici.
      </p>
    </div>
  ),
});
